<template>
  <el-dialog :visible.sync="visible" width="400px">
    <template #title>
      <div
        style="font-size: 18px; color: #303133; font-weight: bold; text-align: center;"
      >
        购买短信包
      </div>
    </template>

    <div style="width: 76%; margin: 0 auto;">
      <div class="d-s-c d-r">
        <div>短信包数量：</div>
        <el-input-number v-model="form.count" size="mini"></el-input-number>
      </div>

      <div class="full mt30" style="color: #ccc;">
        <div>本次购买1000条短信，单条费用为0.06元，费用总计0.60元</div>
        <div>请确认</div>
      </div>
    </div>

    <template #footer>
      <div class="d-c-c d-r">
        <el-button @click="cancel" size="mini">取消</el-button>
        <el-button type="primary" @click="submit" size="mini">确定</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: "buyModel",
  props: {},
  data() {
    return {
      visible: false,
      form: {
        count: 1
      }
    };
  },
  methods: {
    init: function(data) {
      this.visible = true;
    },
    cancel: function() {
      this.visible = false;
    },
    submit: function() {
      this.visible = false;
    }
  },
  created() {}
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/collection/sms_package/component/bugModel.vue